import { Text } from '@chakra-ui/react';

import {
  DriverLicensePurpleGuy,
  HousePurpleGuy,
  JobCardPurpleGuy,
  PointingUpPurpleGuy,
} from '../../assets/Images';
import { LEAccordion, LEAccordionItem } from '../../components/LEAccordion';
import LEAccordionHeader from '../../components/LEAccordion/LEAccordionHeader';
import LEAccordionContainer from '../../components/LEAccordion/LeAccordionContainer';
import { ACCORDION_NAME } from '../../components/LEAccordion/utils';
import TextWithTooltip from '../../components/TextWithTooltip';
import BackButton from '../../components/ui/buttons/BackButton';
import { ButtonWrapper } from '../../components/ui/buttons/ButtonWrapper';
import { getTempInfoCountryConfig } from '../../constants/countries';
import { useTempInfo } from '../../hooks';
import { useSkipPayoffAccordion } from '../../hooks/useSkipPayoffAccordion';
import BuyerCoBuyerSwitch from './components/BuyerCobuyerSwitch';
import Employment from './components/Employment';
import LoanAppDevToolbar from './components/LoanAppDevToolbar';
import Residence from './components/Residence';
import SsnAndBirthdate from './components/SsnAndBirthdate';
import VerifyPersonalInfo from './components/VerifyPersonalInfo';

export const LAST_ACCORDION_ITEM_INDEX = 3;

const WHATS_ON_A_LOAN_APPLICATION_COPY =
  'To prepare your loan application and successfully complete a credit check, ' +
  'lenders require us to collect certain information from our customers. Everything ' +
  'that we ask for is standard on a credit application. With this information, lenders ' +
  'can confirm your identity, establish income & payment histories, and assess any ' +
  'potential risk they could face.';

const LoanApp = () => {
  const skipPayoffAccordion = useSkipPayoffAccordion();
  const { info } = useTempInfo();
  const { creditPull } = getTempInfoCountryConfig(info?.data);

  return (
    <LEAccordionContainer>
      <LEAccordionHeader>Your Application</LEAccordionHeader>
      <Text textAlign="center" fontSize="16px" mb="5px">
        Enter your info below and you'll be on your way to approval for your new loan!{' '}
        <TextWithTooltip label={WHATS_ON_A_LOAN_APPLICATION_COPY}>
          What's on a loan application?
        </TextWithTooltip>
      </Text>
      <BuyerCoBuyerSwitch justifyContent="center" my={4} />
      <LEAccordion name={ACCORDION_NAME.LOAN_APP_ACCORDION} minutes={5}>
        <LEAccordionItem
          accordionKey="loanVerifyPersonalInfo"
          title="PERSONAL INFO"
          imgSrc={PointingUpPurpleGuy}
          imgProps={{ left: '-106px', top: '-120px' }}
        >
          <VerifyPersonalInfo />
        </LEAccordionItem>
        <LEAccordionItem
          accordionKey="loanResidence"
          title="RESIDENTIAL INFO"
          imgSrc={HousePurpleGuy}
          imgProps={{ left: '-76px' }}
        >
          <Residence />
        </LEAccordionItem>
        <LEAccordionItem
          accordionKey="loanEmployment"
          title="EMPLOYMENT INFO"
          imgSrc={JobCardPurpleGuy}
          imgProps={{ top: '-1px', left: '-55px' }}
        >
          <Employment />
        </LEAccordionItem>
        <LEAccordionItem
          accordionKey="loanBirthdate"
          title={`YOUR DATE OF BIRTH${creditPull ? '/SSN' : ''}`}
          imgSrc={DriverLicensePurpleGuy}
          imgProps={{ left: '-76px' }}
        >
          <SsnAndBirthdate />
        </LEAccordionItem>
      </LEAccordion>
      <ButtonWrapper>
        <BackButton
          options={{
            skipPayoffAccordion,
          }}
        />
      </ButtonWrapper>
      <LoanAppDevToolbar />
    </LEAccordionContainer>
  );
};

export default LoanApp;
